import React from 'react';

import {
  type ScopedAttributeDefinitionPrioritizedResult,
  useSearchAttributesPrioritized,
} from '@neptune/shared/attributes-business-logic';

export function useBaseAttributesWithSearchQuery(
  dataSource: ScopedAttributeDefinitionPrioritizedResult,
) {
  const [query, setQuery] = React.useState('');

  const result = useSearchAttributesPrioritized(dataSource, query);

  return {
    query,
    setQuery,
    ...result,
  };
}
